import { fetchBlocksRequest } from "actions";
import { BBABalance } from "components/blockchain";
import { BlockHash } from "components/common/BlockHash";
import Table from "components/datatable/table";
import { BlockInterface } from "interfaces/block.interface";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "reducers";
import { AppDispatch } from "store";
import { formatNumber } from "utils";

const HomeBlocks = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { blocks } = useSelector((state: RootState) => state.blocks);

  useEffect(() => {
    dispatch(fetchBlocksRequest(blocks.meta.page, blocks.meta.take));
  }, [dispatch, blocks.meta.page, blocks.meta.take]);

  // Define the columns with optional "render" for custom display
  const columns = [
    {
      title: "Block Height",
      render: (value: any, block: BlockInterface) => (
        <Link
          to={`/block/${block.block_number}`}
          className="text-small text-green-900"
        >
          <div className="truncateWrapper">
            <p className="text-small truncate text-green-900">
              {formatNumber(block.block_number, 0)}
            </p>
          </div>
          <p className="text-xsmall text-gray-700">
            {moment.unix(block.block_time).fromNow()}
          </p>
        </Link>
      ),
    },
    {
      title: "Block Hash",
      render: (value: any, block: BlockInterface) => (
        <div className="flex max-w-[160px] gap-[1px]">
          <BlockHash
            hash={block.block_hash}
            height={block.block_number}
            truncate={16}
            link
          />
        </div>
      ),
    },
    {
      title: "Txs Count",
      render: (value: any, block: BlockInterface) => (
        <p className="text-small">
          {formatNumber(block.transactions?.length || 0, 0)}
        </p>
      ),
    },
    {
      title: "Reward",
      render: (value: any, block: BlockInterface) => (
        <BBABalance
          daltons={block.rewards.reduce(
            (acc: any, item: any) => acc + item.daltons,
            0
          )}
        />
      ),
    },
  ];

  return (
    <Table columns={columns} data={blocks.data} tableClassName="table w-full" />
  );
};

export default HomeBlocks;
